export const FETCH_UPSELL = 'upsell/FETCH'
export const FETCH_UPSELL_SUCCESS = 'upsell/FETCH_SUCCESS'
export const FETCH_UPSELL_FAILURE = 'upsell/FETCH_FAILURE'

export const fetch = params => {
    return {
        type: FETCH_UPSELL,
        value: {
            params
        }
    };
};

export const fetchSuccess = data => {
    return {
        type: FETCH_UPSELL_SUCCESS,
        value: data
    };
};

export const fetchFailure = error => {
    return {
        type: FETCH_UPSELL_FAILURE,
        value: error
    };
};
